(() => {
  "use strict";

  const FIELD_ORDER = [
    "Produktart", "Marke", "Bereich/Küche", "Inhalt", "Verwendung",
    "Geeignete Gerichte", "Zubereitung", "Geschmack", "Konsistenz",
    "Schärfegrad", "Charakter", "Passt zu", "FAQ", "Ersatzprodukte",
    "Suchbegriffe", "Hinweis"
  ];

  const CUSTOMER_FIELD_ORDER = [
    "Produktart", "Marke", "Bereich/Küche", "Inhalt", "Verwendung",
    "Geeignete Gerichte", "Zubereitung", "Geschmack", "Konsistenz",
    "Schärfegrad", "Charakter", "Passt zu", "FAQ"
  ];

  const LABEL_PATTERN = new RegExp(
    "(?:^|[\\s/])(" + [
      "AIO[- ]Produktprofil", "Produktart", "Marke",
      "Bereich\\s*/\\s*(?:Küche|Kueche)", "Inhalt",
      "(?:Typische\\s+)?Verwendung", "Geeignete\\s+Gerichte",
      "Zubereitung(?:smöglichkeiten|smoeglichkeiten)?", "Geschmack",
      "Konsistenz", "(?:Schärfegrad|Schaerfegrad|Schärfe|Schaerfe)",
      "Charakter", "Passt\\s+(?:gut\\s+)?zu", "(?:Ersatzprodukte|Ersatz)",
      "FAQ", "(?:Suchbegriffe|Such-\\s*und\\s*Rezeptbegriffe)",
      "(?:Prüfhinweis|Pruefhinweis|Hinweis)"
    ].join("|") + ")\\s*:\\s*",
    "giu"
  );

  function canonicalLabel(value) {
    const key = String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s*\/\s*/g, "/")
      .replace(/\s+/g, " ")
      .trim();
    if (key.startsWith("aio-") || key.startsWith("aio ")) return "";
    if (key === "produktart") return "Produktart";
    if (key === "marke") return "Marke";
    if (key.startsWith("bereich/")) return "Bereich/Küche";
    if (key === "inhalt") return "Inhalt";
    if (key.endsWith("verwendung")) return "Verwendung";
    if (key === "geeignete gerichte") return "Geeignete Gerichte";
    if (key.startsWith("zubereitung")) return "Zubereitung";
    if (key === "geschmack") return "Geschmack";
    if (key === "konsistenz") return "Konsistenz";
    if (["scharfegrad", "schaerfegrad", "scharfe", "schaerfe"].includes(key)) return "Schärfegrad";
    if (key === "charakter") return "Charakter";
    if (key === "passt zu" || key === "passt gut zu") return "Passt zu";
    if (key === "ersatz" || key === "ersatzprodukte") return "Ersatzprodukte";
    if (key === "faq") return "FAQ";
    if (key === "suchbegriffe" || key.includes("rezeptbegriffe")) return "Suchbegriffe";
    if (["hinweis", "prufhinweis", "pruefhinweis"].includes(key)) return "Hinweis";
    return "";
  }

  function parseProfile(raw) {
    const text = String(raw || "").normalize("NFC").replace(/\r\n?/g, "\n");
    const matcher = new RegExp(LABEL_PATTERN.source, LABEL_PATTERN.flags);
    const matches = Array.from(text.matchAll(matcher));
    const fields = {};
    matches.forEach((match, index) => {
      const label = canonicalLabel(match[1]);
      if (!label) return;
      const start = (match.index || 0) + match[0].length;
      const end = index + 1 < matches.length ? matches[index + 1].index : text.length;
      const value = text.slice(start, end).replace(/\s+/g, " ").replace(/^[\s\-/]+|[\s\-/]+$/g, "").trim();
      if (!value) return;
      if (fields[label] && !fields[label].toLowerCase().includes(value.toLowerCase())) {
        fields[label] += `; ${value}`;
      } else {
        fields[label] = value;
      }
    });
    ["Geeignete Gerichte", "Geschmack", "Konsistenz", "Passt zu", "Ersatzprodukte", "Suchbegriffe"].forEach((label) => {
      if (fields[label]) fields[label] = splitItems(fields[label]).join(", ");
    });
    return fields;
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function appendFact(parent, label, value) {
    const fact = element("div", "toa-aio-profile__fact");
    fact.append(element("span", "toa-aio-profile__label", label));
    fact.append(element("span", "toa-aio-profile__value", value));
    parent.append(fact);
  }

  function splitItems(...values) {
    const items = values
      .flatMap((value) => String(value || "")
        .replace(/\s+und\s+([^,;]+)$/i, ", $1")
        .split(/[,;]\s*/)
        .map((item) => item.trim().replace(/[.;]+$/g, ""))
        .filter(Boolean));
    const result = [];
    const tokenSets = [];
    items.forEach((item) => {
      const key = item.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("de")
        .replace(/\u00df/g, "ss")
        .replace(/ae/g, "a")
        .replace(/oe/g, "o")
        .replace(/ue/g, "u")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
      const tokens = new Set(key.split(/\s+/).filter(Boolean));
      if (!key || tokenSets.some((entry) => entry.key === key)) return;
      let replaceAt = -1;
      for (let index = 0; index < tokenSets.length; index += 1) {
        const existing = tokenSets[index].tokens;
        const currentInsideExisting = tokens.size === 1 && [...tokens].every((token) => existing.has(token));
        const existingInsideCurrent = existing.size === 1 && [...existing].every((token) => tokens.has(token));
        if (currentInsideExisting) return;
        if (existingInsideCurrent) { replaceAt = index; break; }
      }
      if (replaceAt >= 0) {
        result[replaceAt] = item;
        tokenSets[replaceAt] = { key, tokens };
      } else {
        result.push(item);
        tokenSets.push({ key, tokens });
      }
    });
    return result.slice(0, 16);
  }

  function appendTextSection(parent, title, value, className = "") {
    const section = element("section", `toa-aio-profile__section${className ? ` ${className}` : ""}`);
    section.append(element("h3", "", title));
    section.append(element("p", "", value));
    parent.append(section);
  }

  function appendInlineSection(parent, kicker, title, values, className = "") {
    const items = splitItems(...values);
    if (!items.length) return;
    const section = element("section", `toa-aio-profile__section${className ? ` ${className}` : ""}`);
    if (kicker) section.append(element("span", "toa-aio-profile__kicker", kicker));
    section.append(element("h3", "", title));
    const list = element("ul", "toa-aio-profile__inline-list");
    items.forEach((item) => list.append(element("li", "toa-aio-profile__inline-item", item)));
    section.append(list);
    parent.append(section);
  }

  function parseFaqs(value) {
    const text = String(value || "").replace(/\s+/g, " ").trim();
    const pairs = text.split(/\s*\|\s*(?=Frage\s*:)/i).map((part) => {
      const explicit = part.match(/^Frage\s*:\s*(.+?)\s+Antwort\s*:\s*(.+)$/i);
      return explicit ? { question: explicit[1].trim(), answer: explicit[2].trim() } : null;
    }).filter(Boolean);
    if (pairs.length) return pairs.slice(0, 3);
    return [{
      question: "Wie kann ich dieses Produkt verwenden?",
      answer: text || "Bitte die Verwendungshinweise auf der Produktverpackung beachten."
    }];
  }

  function appendFaq(parent, value) {
    const section = element("section", "toa-aio-profile__section toa-aio-profile__section--faq");
    section.append(element("h3", "", "Häufige Fragen"));
    parseFaqs(value).forEach((faq) => {
      const item = element("details", "toa-aio-profile__faq-item");
      item.append(element("summary", "toa-aio-profile__faq-question", faq.question));
      item.append(element("p", "toa-aio-profile__faq-answer", faq.answer));
      section.append(item);
    });
    parent.append(section);
  }

  function buildProfile(fields) {
    const profile = element("div", "toa-aio-profile");
    const factLabels = ["Produktart", "Marke", "Bereich/Küche", "Inhalt", "Geschmack", "Konsistenz", "Schärfegrad", "Charakter"];
    const presentFacts = factLabels.filter((label) => fields[label]);
    if (presentFacts.length) {
      const facts = element("div", "toa-aio-profile__facts");
      presentFacts.forEach((label) => appendFact(facts, label, fields[label]));
      profile.append(facts);
    }
    if (fields.Verwendung) appendTextSection(profile, "So verwendest du das Produkt", fields.Verwendung);
    if (fields.Zubereitung) appendTextSection(profile, "Zubereitung", fields.Zubereitung);
    appendInlineSection(
      profile,
      "TOA Küchenideen",
      "Gerichte und Kombinationen",
      [fields["Geeignete Gerichte"], fields["Passt zu"]],
      "toa-aio-profile__section--kitchen"
    );
    if (fields.FAQ) appendFaq(profile, fields.FAQ);
    profile.dataset.toaAioFields = CUSTOMER_FIELD_ORDER.filter((label) => fields[label]).join(",");
    return profile;
  }

  function enhance(root = document) {
    root.querySelectorAll(".cc-accordion-item:not([data-toa-aio-checked])").forEach((item) => {
      const title = item.querySelector(":scope > .cc-accordion-item__title");
      const content = item.querySelector(":scope > .cc-accordion-item__panel .cc-accordion-item__content");
      if (!title || !content) return;
      item.dataset.toaAioChecked = "true";
      const normalizedTitle = title.textContent.replace(/\s+/g, " ").trim().toLowerCase();
      if (!normalizedTitle.startsWith("produktinformation")) return;
      const source = content.querySelector("template[data-toa-aio-source]");
      const raw = source ? source.content.textContent : content.textContent;
      const fields = parseProfile(raw);
      const customerCount = CUSTOMER_FIELD_ORDER.filter((label) => fields[label]).length;
      if (!customerCount) return;
      content.replaceChildren(buildProfile(fields));
      item.dataset.toaAioEnhanced = "true";
    });
  }

  function run() {
    enhance(document);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run, { once: true });
  else run();
  window.addEventListener("load", run, { once: true });
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
